import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localesMap, matchLocalesMap } from '../constant.js'
import { globalStyles } from '../global-styles.js'
import { IMerchantCustomizeConfig } from '../types/customSettings.js';

@customElement('pp-cashier-footer')
export class PpCashierFooter extends LitElement {
  static styles = [
    globalStyles,
    css`
      :host {
        display: none;
        width: 100%;
      }

      footer {
        margin: 0 auto;
        height: 3rem;
        padding: 0 0.75rem;
        border-top: var(--pp-border-color);
        max-width: 36rem;
      }

      #lang-select {
        outline: none;
        text-align: right;
        padding-right: 0.625rem;
        background-color: transparent;
        color: var(--pp-primary-text-color);
      }

      @media only screen and (min-width: 0) and (max-width: 576px){
        :host {
          display: block;
        }
      }
    `
  ];

  @property({ type: String }) locale = '';

  @property({ type: String }) width = '36rem';
  
  @property({ type: Object }) customizeConfig: Partial<IMerchantCustomizeConfig> = {};

  get languages () {
    const { languages } = this.customizeConfig;

    return languages ? matchLocalesMap(languages) : localesMap;
  }

  private _handleLocaleChange(event: Event) {
    const { value } = event.target as HTMLSelectElement;
    this.dispatchEvent(new CustomEvent('locale-changed', { detail: value }));
  }

  private _renderLocalsOptions() {
    return this.languages.map(locale => html`
      <option 
        value=${locale.value}
        .selected=${this.locale === locale.value}
      >
        ${locale.label}
      </option>
    `)
  }

  render() {
    return this.languages.length > 1? html`
      <footer class="flex justify-end items-center" style="max-width: ${this.width}">
        <div class="pp-switch-locales">
          <select id="lang-select" class="text-xs" @change="${this._handleLocaleChange}">
            ${this._renderLocalsOptions()}
          </select>
        </div>
      </footer>
    `: '';
  }
}
